import type { RouteRecordRaw } from 'vue-router'

const nebulaAiRoutes: RouteRecordRaw = {
  path: '/nebula-ai',
  name: 'nebula-ai',
  meta: { layout: 'DashboardLayout', requiresAuth: true, title: 'common.titles.nebula_ai' },
  component: () => import('@/pages/nebula-ai/NebulaAIPage.vue'),
}

export default nebulaAiRoutes
